<div class="{{'tw-grid ' + externalClass}}" style="display:grid">
  <label for="@next" class="tw-text-s tw-font-semibold tw-font-base-850 tw-mb-1" [class.form-required]="required">{{label}}
    <i *ngIf="helpText" class="pi pi-info-circle px-2" [pTooltip]="helpText" tooltipPosition="right"></i>
  </label>
  <ng-content></ng-content>
</div>
